import styled from 'styled-components'

export const IconWrapper = styled.div`
	display: flex;
	width: 48px;
	height: 48px;
	align-items: center;
	justify-content: center;
`
